import store from '@/store/BookingStore';
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService';
import { calculateAge } from '@/utils/dateUtilts';
import { InitBookingRequest } from '@/logic/createRequestParams';
import { Option } from '../../../requests-module/src';
import { PrestType } from '../../../requests-module/src/booking-state/BookingV2';

/**
 * Builds the prestations string for InitBookingRequest from booking options.
 * Format: id-quantity-travellersCount--id2-quantity2-travellersCount2
 */
function buildPrestationsString(options: Option[]): string {
    return options
        .filter(opt => opt.quantity > 0 && opt.prestTypeId == PrestType.Accomodation)
        .map(opt => `${opt.id}-${opt.quantity}-${opt.maxCapacity}`)
        .join('-')
}

/**
 * Create a new booking with the same data as the current booking, but with new participant ages.
 * @param newAges number[] - The ages of the new participants (e.g. [18, 18])
 * @returns Promise<{ error: string } | Booking>
 */
export async function createNewBookingWithNewParticipants(newAges?: number[]) {
    const booking = store.getters.getBooking;
    if (!booking) throw new Error('No booking found in store');

    const ages = newAges ?? booking.travellers.map(t => {
        const age = calculateAge(t.birthday, booking.returnDate);
        if (age > 18) {
            return 18;
        }
        return age;
    });

    // Build participants string from new ages
    const participants = ages.join('-');
    // Build prestations string from current options
    const prestations = buildPrestationsString(booking.options);

    const request: InitBookingRequest = {
        lihe_id: booking.liheId,
        participants,
        start_date: booking.departureDate,
        end_date: booking.returnDate,
        prestations,
        season: 'H',
        prest_id: booking.packageId,
        website: booking.website || 'www.travelski.com',
    };

    if (booking.origin) {
        request.origin = booking.origin
    }

    console.log("[createNewBookingWithNewParticipants] request:", (request));

    const response = await BookingFunnelService.initBookingFlight(request);

    if ('error' in response) {
        throw new Error('Error with api')
    }
    return response.boReference
} 